// Module
var code = "<div class=\"modal-panel\">\n  <div class=\"modal-panel-wpapper\">\n    <div class=\"modal-panel-body\"></div>\n  </div>\n</div>\n";
// Exports
module.exports = code;